export default "__VITE_ASSET__fTziHkoW__"